import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=610860cc"
import script from "./AccordionCard.vue?vue&type=script&lang=js"
export * from "./AccordionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports